import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import IdentifyFrontendCode from "./identify-frontend-code.mdx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Linking events to specific users enables you to build a full picture of how they're using your product across different sessions, devices, and platforms. `}</p>
    <p>{`This is straightforward to do when `}<a parentName="p" {...{
        "href": "/docs/product-analytics/capture-events?tab=Node.js"
      }}>{`capturing backend events`}</a>{`, as you associate events to a specific user using a `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{`, which is a required argument. `}</p>
    <p>{`However, in the frontend of a `}<a parentName="p" {...{
        "href": "/docs/libraries/js/features#capturing-events"
      }}>{`web`}</a>{` or `}<a parentName="p" {...{
        "href": "/docs/libraries/ios#capturing-events"
      }}>{`mobile app`}</a>{`, a `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` is not a required argument — PostHog's SDKs will generate an anonymous `}<inlineCode parentName="p">{`distinct_id`}</inlineCode>{` for you automatically and you can capture events anonymously, provided you use the appropriate `}<a parentName="p" {...{
        "href": "/docs/libraries/js/features#capturing-anonymous-events"
      }}>{`configuration`}</a>{`.`}</p>
    <p>{`To link events to specific users, call `}<inlineCode parentName="p">{`identify`}</inlineCode>{`:`}</p>

    <IdentifyFrontendCode mdxType="IdentifyFrontendCode" />
    <p>{`Events captured after calling `}<inlineCode parentName="p">{`identify`}</inlineCode>{` are identified events and this creates a person profile if one doesn't exist already.`}</p>
    <p>{`Due to the cost of processing them, anonymous events can be up to 4x cheaper than identified events, so it's recommended you only capture identified events when needed.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      